import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import styles from './styles';

function SidebarOpenableOptionItem({ optionName, isActive, linkTo, onPress }) {
  const styleVar = isActive && styles.activeItemIndicator;
  return (
    <UTTouchableWithoutFeedback onClick={onPress && onPress} style={{ ...styles.container, ...styleVar }}>
      {linkTo ? (
        <Link to={linkTo} style={styles.link}>
          <UTLabel primary small style={isActive ? styles.activeText : styles.inactiveText}>
            {optionName}
          </UTLabel>
        </Link>
      ) : (
        <UTLabel primary small style={isActive ? styles.activeText : styles.inactiveText}>
          {optionName}
        </UTLabel>
      )}
    </UTTouchableWithoutFeedback>
  );
}

SidebarOpenableOptionItem.propTypes = {
  optionName: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onPress: PropTypes.func,
  linkTo: PropTypes.string
};

export default Radium(SidebarOpenableOptionItem);
